import { cn } from "src/common/utils";

const OpsgenieIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-1")}>
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="100%" 
      height="100%"
      viewBox="0 0 256 320"
    >
      <circle fill="#2684FF" cx="128" cy="76" r="76"/>
      <path d="M121 303c-50-32-91-75-120-126l62-29c4-2 9-1 11 3 29 49 72 88 124 112-19 19-40 36-63 51-4 2-9 2-14-11z" fill="#0052CC"/>
      <path d="M135 303c50-32 91-75 120-126l-62-29c-4-2-9-1-11 3-29 49-72 88-124 112 19 19 40 36 63 51 4 2 9 2 14-11z" fill="#2684FF"/>
    </svg>
  </div>
);

export default OpsgenieIcon;